// extracted by mini-css-extract-plugin
export var downArrow = "_aq-0";
export var label = "_aq-1";
export var treatmentCard = "_aq-3";
export var upArrow = "_aq-2";